/* Phosis reviews carousel.
   The Stamped widget renders its review cards into `.stamped-main-widget`, which our
   CSS turns into a horizontal scroll track. This wires the prev/next arrows to it and
   keeps them disabled while there's nothing (or nothing more) to scroll. The widget
   loads async, so we (re)bind on a poll and on Stamped's load event. */
(function () {
  function init(root) {
    var carousel = root || document.querySelector('[data-phosis-reviews]');
    if (!carousel) return;

    var track = carousel.querySelector('#stamped-reviews-tab');
    var prev = carousel.querySelector('[data-reviews-prev]');
    var next = carousel.querySelector('[data-reviews-next]');
    if (!track || !prev || !next) return false;

    if (carousel.dataset.carouselBound === '1') { updateNav(track, prev, next); return true; }
    carousel.dataset.carouselBound = '1';

    function step() { return Math.max(track.clientWidth * 0.9, 280); }
    prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', function () { updateNav(track, prev, next); }, { passive: true });
    window.addEventListener('resize', function () { updateNav(track, prev, next); });

    updateNav(track, prev, next);
    return true;
  }

  function updateNav(track, prev, next) {
    var scrollable = track.scrollWidth - track.clientWidth > 4;
    var nav = track.closest('[data-phosis-reviews]').querySelector('.phosis-reviews__nav');
    if (nav) nav.style.display = scrollable ? '' : 'none';
    if (!scrollable) return;
    prev.disabled = track.scrollLeft <= 4;
    next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 4;
  }

  function ready() {
    // The Stamped track mounts asynchronously — poll for it, then stop once bound.
    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      if (init() || tries >= 40) clearInterval(timer);
    }, 400);
    document.addEventListener('stamped:reviews:load', function () { init(); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready);
  } else {
    ready();
  }
})();
